
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import GenerateBillForm from "../components/generateBill";
import BillView from "../components/BillView";
import Select from "react-select";
import { API_BASE_URL } from "../../../../config";

const VisitTable = ({ customer, onClose, adminPermissions, isSuperAdmin }) => {
  const [showForm, setShowForm] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [visitDate, setVisitDate] = useState("");
  const [status, setStatus] = useState("Finalized");
  const [projects, setProjects] = useState([]);
  const [visits, setVisits] = useState(customer.visits || []);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [, setLoadingBills] = useState(false);

  const [editVisitId, setEditVisitId] = useState(null);
  const isEditing = Boolean(editVisitId);

  const [selectedVisitForBill, setSelectedVisitForBill] = useState(null);
  const [selectedBillId, setSelectedBillId] = useState(null);

  const [project, setProject] = useState(null);

  // const handleProjectChange = (e) => {
  //   const id = e.target.value;
  //   setProjectId(id);

  //   // चुने हुए project को find करो
  //   const selected = projects.find((p) => p._id === id);
  //   setProject(selected || null);
  // };

  const handleProjectChange = (selectedOption) => {
    // selectedOption null ho sakta hai jab clear ho
    const id = selectedOption?.value || ""; // optional chaining
    setProjectId(id);

    const selected = projects.find((p) => p._id === id);
    setProject(selected || null);
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      return new Date(dateStr).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      });
    } catch {
      return dateStr;
    }
  };





  const hasPermission = (module, action) => {
    return (
      isSuperAdmin ||
      (adminPermissions[module] && adminPermissions[module][action])
    );
  };

  const handleRestrictedAction = (module, action, callback) => {
    if (!hasPermission(module, action)) {
      toast.error(`You don't have permission to ${action} ${module}`);
      return;
    }
    callback();
  };

  // Fetch all projects
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${API_BASE_URL}/api/project/get-all-projects?page=1&limit=99999`,
          { headers: { token } }
        );
        setProjects(res.data.result || []);
      } catch {
        toast.error("Failed to load projects");
      } finally {
        setLoadingProjects(false);
      }
    };
    fetchProjects();
  }, []);

  const refreshBills = useCallback(async () => {
    const token = localStorage.getItem("token");
    setLoadingBills(true);
    try {
      const updatedVisits = await Promise.all(
        (customer.visits || []).map(async (visit) => {
          if (!visit._id) return visit;
          try {
            const res = await axios.get(
              `${API_BASE_URL}/api/billRecord/get-bill-by-visit/${visit._id}`,
              { headers: { token } }
            );
            return {
              ...visit,
              bill: res.data.success
                ? res.data.result.billRecord
                : visit.bill || null,
            };
          } catch (error) {
            // console.error("Error fetching bill:", error);
            return { ...visit, bill: visit.bill || null };
          }
        })
      );
      setVisits(updatedVisits);
    } catch (error) {
      // console.error("Error refreshing bills:", error);
      toast.error("Failed to refresh bill data");
    } finally {
      setLoadingBills(false);
    }
  }, [customer.visits]);

  useEffect(() => {
    refreshBills();
  }, [refreshBills]);

  const handleAddOrUpdateVisit = async () => {
    if (!projectId || !visitDate || !status) {
      toast.error("All fields are required.");
      return;
    }
    const token = localStorage.getItem("token");

    if (isEditing) {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/api/propertyVisit/edit-propertyvisit/${editVisitId}`,
          { visitDate, status },
          { headers: { token } }
        );
        if (res.data.success) {
          toast.success("Visit updated successfully!");
          setVisits((prev) =>
            prev.map((visit) =>
              visit._id === editVisitId
                ? { ...visit, visitDate, status }
                : visit
            )
          );
          refreshBills();
          resetForm();
        } else {
          toast.error(res.data.message || "Failed to update visit.");
        }
      } catch {
        toast.error("Error updating visit.");
      }
    } else {
      try {
        const visitDateNew = new Date(visitDate).toISOString();

        const res = await axios.post(
          `${API_BASE_URL}/api/propertyVisit/add-propertyvisit`,
          { customerId: customer._id, projectId, visitDate: visitDateNew, status },
          { headers: { token } }
        );
        if (res.data.success) {
          toast.success("Visit added successfully!");
          //  refreshBills();
          resetForm();
          setProject(null);
          setShowForm(false);
          onClose();
          // setVisits((prev) => [...prev, res.data.result.newVisit]);

        } else {
          toast.error(res.data.message || "Failed to add visit.");
        }
      } catch {
        toast.error("Error adding visit.");
      }
    }
  };

  const handleEditClick = (visit) => {
    setShowForm(true);
    setEditVisitId(visit._id);
    setProjectId(visit.projectId?._id || "");

    if (visit.visitDate) {
      // const utcDate = new Date(visit.visitDate).toISOString().slice(0, 16);
      // setVisitDate(utcDate);
      const utcDate = visit.visitDate
        ? new Date(
          new Date(visit.visitDate).getTime() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .slice(0, 16)
        : "";

      setVisitDate(utcDate);

    } else {
      setVisitDate("");
    }

    setStatus(visit.status || "Finalized");
  };

  const resetForm = () => {
    setEditVisitId(null);
    setProjectId("");
    setVisitDate("");
    setStatus("Finalized");
    setShowForm(false);
  };

  const options = projects?.map((p) => ({
    value: p._id,
    label: `${p.projectName || "Unnamed Project"} (${p?.flatType || ""})`,
  }));

  return (
    <div className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm ">
      <div className="w-full max-w-4xl rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-800 max-h-[600px] overflow-y-scroll">
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
            Visits for {customer.customerName}
          </h2>
          <div className="flex items-center gap-2">
            {/* <button
              onClick={() => {
                resetForm();
                setShowForm(true);
              }}
              className="rounded bg-green-600 px-4 py-1.5 text-sm text-white hover:bg-green-700"
            >
              + Add Visit
            </button> */}

            <button
              onClick={() =>
                handleRestrictedAction("visit", "add", () => {
                  resetForm();
                  setShowForm(true);
                })
              }
              disabled={!hasPermission("visit", "add")}
              className={`rounded px-4 py-1.5 text-sm text-white ${hasPermission("visit", "add")
                ? "bg-green-600 hover:bg-green-700"
                : "cursor-not-allowed bg-gray-400"
                }`}
            >
              + Add Visit
            </button>

            <button
              className="rounded bg-red-700 px-2 py-1 text-white transition hover:bg-red-800"
              onClick={onClose}
            >
              &times;
            </button>
          </div>
        </div>

        {/* Add/Edit Form */}
        {showForm && (
          <div className="mb-4 rounded-lg border border-gray-300 bg-white p-4 dark:border-gray-500 dark:bg-gray-700  ">
            <div className="mb-3 grid grid-cols-1 gap-4 md:grid-cols-3">
              <div className="flex flex-col">
                <label className="mb-1 text-sm font-medium">Project</label>
                {/* <select
                  value={projectId}
                  onChange={handleProjectChange}
                  className="rounded border p-2"
                  disabled={isEditing}
                >
                  <option value="">Select Project</option>
                  {loadingProjects ? (
                    <option disabled>Loading projects...</option>
                  ) : (
                    projects.map((p) => (
                      <option key={p._id} value={p._id}>
                        {p.projectName || "Unnamed Project"} ({p?.flatType})
                      </option>
                    ))
                  )}
                </select> */}

                <Select
                  value={options.find((o) => o.value === projectId)}
                  onChange={handleProjectChange}
                  options={options}
                  isDisabled={isEditing || loadingProjects}
                  isClearable
                  placeholder={loadingProjects ? "Loading projects..." : "Select Project"}
                  menuPortalTarget={document.body}  // dropdown ko body ke andar render kare
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }) // highest z-index
                  }}
                />

              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-sm font-medium">
                  Visit Date & Time
                </label>
                <input
                  type="datetime-local"
                  value={visitDate}
                  onChange={(e) => setVisitDate(e.target.value)}
                  onInput={(e) => setVisitDate(e.target.value)}
                  className="rounded border p-2"
                />
              </div>
              <div className="flex flex-col">
                <label className="mb-1 text-sm font-medium">Status</label>
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="rounded border p-2"
                >
                  <option value="Finalized">Finalized</option>
                  <option value="Not Interested">Not Interested</option>
                  <option value="Visited">Visited</option>
                  <option value="Not Visited">Not Visited</option>
                  <option value="Cost sheet share">Cost Sheet Share</option>
                </select>
              </div>

              {project && (
                <div className="flex flex-col">
                  <h3 className="mb-3 border-b pb-1 text-lg font-semibold">
                    Project Details
                  </h3>
                  <p><strong>Project:</strong> {project.projectName || "-"}</p>
                  <p><strong>Type:</strong> {project.projectType || "-"}</p>
                  <p><strong>Flat Type:</strong> {project.flatType || "-"}</p>
                  <p><strong>Flat Facing:</strong> {project.flatFacing || "-"}</p>
                  <p><strong>Amenities:</strong> {project.amenities || "-"}</p>
                  <p><strong>Address:</strong> {project.projectAddress || "-"}</p>
                </div>
              )}


            </div>



            <div className="flex justify-end gap-2">
              <button
                onClick={resetForm}
                className="rounded border px-4 py-1.5 text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleAddOrUpdateVisit}
                className={`rounded px-4 py-1.5 text-sm text-white ${isEditing
                  ? "bg-yellow-600 hover:bg-yellow-700"
                  : "bg-blue-600 hover:bg-blue-700"
                  }`}
              >
                {isEditing ? "Update" : "Add"}
              </button>
            </div>
          </div>
        )}



        {/* Visits Table */}
        {visits.length > 0 ? (
          <div className="max-h-[400px] overflow-y-auto rounded-lg border border-gray-300 dark:border-gray-700">
            <table className="w-full border-collapse text-sm">
              <thead className="sticky top-0 z-10 bg-gray-100 dark:bg-gray-700">
                <tr>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Project Name
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Project Type
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Property Type
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Address
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Visit Date & Time
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Status
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Bill
                  </th>
                  <th className="border border-gray-300 p-3 text-left dark:border-gray-600">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {visits.map((visit) => {
                  const project = visit.projectId || {};
                  return (
                    <tr key={visit._id} className="border-t dark:text-white">
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        {project.projectName || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        {project.projectType || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        {project.propertyType || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        {project.projectAddress || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        {formatDateTime(visit.visitDate)}
                      </td>

                      {/* Status */}
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        <span
                          className={`whitespace-nowrap rounded-full px-2 py-1 text-xs font-semibold ${visit.status === "Not Interested" ||
                            visit.status === "Not Visited"
                            ? "bg-red-100 text-red-700"
                            : visit.status === "Visited" ||
                              visit.status === "Cost sheet share"
                              ? "bg-green-100 text-green-700"
                              : "bg-gray-100 text-gray-700"
                            }`}
                        >
                          {visit.status}
                        </span>
                      </td>

                      {/* Bill */}
                      <td className="border border-gray-300 p-3 dark:border-gray-600">
                        <span
                          className={`whitespace-nowrap rounded-full px-2 py-1 text-xs font-semibold ${!visit.bill
                            ? "bg-red-100 text-red-700"
                            : "bg-green-100 text-green-700"
                            }`}
                        >
                          {visit.bill ? "Generated" : "Not Generated"}
                        </span>
                      </td>

                      {/* Actions */}
                      <td className=" flex gap-2 p-3 dark:border-gray-600">
                        {/* <button
                          onClick={() => handleEditClick(visit)}
                          className="text-yellow-600 hover:text-yellow-800"
                        >
                          <FaEdit />
                        </button> */}

                        <button
                          onClick={() =>
                            handleRestrictedAction("visit", "edit", () =>
                              handleEditClick(visit)
                            )
                          }
                          disabled={!hasPermission("visit", "edit")}
                          className={`text-yellow-600 hover:text-yellow-800 ${!hasPermission("visit", "edit") &&
                            "cursor-not-allowed opacity-50"
                            }`}
                        >
                          <FaEdit />
                        </button>

                        {/* {!visit.bill ? (
                          <button
                            onClick={() => setSelectedVisitForBill(visit)}
                            className="rounded bg-blue-600 px-2 py-1 text-xs text-white hover:bg-blue-700"
                          >
                            Generate Bill
                          </button>
                        ) : (
                          <button
                            onClick={() => setSelectedBillId(visit.bill._id)}
                            className="rounded bg-green-600 px-2 py-1 text-xs text-white hover:bg-green-700"
                          >
                            View Bill
                          </button>
                        )} */}

                        {!visit.bill ? (
                          <button
                            onClick={() =>
                              handleRestrictedAction("bill", "add", () =>
                                setSelectedVisitForBill(visit)
                              )
                            }
                            disabled={!hasPermission("bill", "add")}
                            className={`rounded px-2 py-1 text-xs text-white ${hasPermission("bill", "add")
                              ? "bg-blue-600 hover:bg-blue-700"
                              : "cursor-not-allowed bg-gray-400"
                              }`}
                          >
                            Generate Bill
                          </button>
                        ) : (
                          <button
                            onClick={() => setSelectedBillId(visit.bill._id)}
                            className="rounded bg-green-600 px-2 py-1 text-xs text-white hover:bg-green-700"
                          >
                            View Bill
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="mt-4 dark:text-white">No visits recorded.</p>
        )}
      </div>

      {/* Generate Bill Modal */}
      {selectedVisitForBill && (
        <GenerateBillForm
          visit={selectedVisitForBill}
          onClose={() => setSelectedVisitForBill(null)}
          onBillGenerated={(billData) => {
            setVisits((prevVisits) =>
              prevVisits.map((v) =>
                v._id === selectedVisitForBill._id
                  ? { ...v, bill: billData }
                  : v
              )
            );
            setSelectedVisitForBill(null);
            refreshBills();
          }}
        />
      )}

      {/* Bill View Modal */}
      {selectedBillId && (
        <BillView
          billId={selectedBillId}
          onClose={() => setSelectedBillId(null)}
          adminPermissions={adminPermissions}
          isSuperAdmin={isSuperAdmin}
        />
      )}
    </div>
  );
};

export default VisitTable;
